import Ie from "../../@babel/runtime/helpers/esm/extends2.mjs";
import N from "../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import X from "../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import p from "../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import Fe from "../../@babel/runtime/helpers/esm/objectWithoutProperties2.mjs";
import * as s from "react";
import { useState as Z, useRef as v } from "react";
import Ae from "../../classnames/index2.mjs";
import Ke from "./Filler.mjs";
import Ve from "./ScrollBar.mjs";
import We from "./hooks/useChildren.mjs";
import ke from "./hooks/useHeights.mjs";
import ze from "./hooks/useScrollTo.mjs";
import Oe from "./hooks/useDiffItem.mjs";
import Be from "./hooks/useFrameWheel.mjs";
import Ye from "./hooks/useMobileTouchMove.mjs";
import $e from "./hooks/useOriginScroll.mjs";
import ee from "../../rc-util/es/hooks/useLayoutEffect.mjs";
var je = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "component", "onScroll", "onVisibleChange", "innerProps"], Ue = [], qe = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function Ge(t, re) {
  var b = t.prefixCls, d = b === void 0 ? "rc-virtual-list" : b, te = t.className, i = t.height, m = t.itemHeight, I = t.fullHeight, ne = I === void 0 ? !0 : I, oe = t.style, C = t.data, le = t.children, S = t.itemKey, ie = t.virtual, F = t.direction, A = t.component, ae = A === void 0 ? "div" : A, R = t.onScroll, K = t.onVisibleChange, fe = t.innerProps, se = Fe(t, je), a = !!(ie !== !1 && i && m), V = a && C && m * C.length > i, ce = Z(0), W = p(ce, 2), c = W[0], ue = W[1], ve = Z(!1), k = p(ve, 2), de = k[0], z = k[1], me = Ae(d, X({}, "".concat(d, "-rtl"), F === "rtl"), te), n = C || Ue, l = v(), O = v(), B = v(), h = s.useCallback(function(e) {
    return typeof S == "function" ? S(e) : e == null ? void 0 : e[S];
  }, [S]), he = {
    getKey: h
  };
  function M(e) {
    ue(function(r) {
      var o;
      typeof e == "function" ? o = e(r) : o = e;
      var u = Te(o);
      return l.current.scrollTop = u, u;
    });
  }
  var Y = v({
    start: 0,
    end: n.length
  }), ge = v(), pe = Oe(n, h), Se = p(pe, 1), Me = Se[0];
  ge.current = Me;
  var He = ke(h, null, null), H = p(He, 4), xe = H[0], $ = H[1], j = H[2], ye = H[3], x = s.useMemo(function() {
    if (!a)
      return {
        scrollHeight: void 0,
        start: 0,
        end: n.length - 1,
        offset: void 0
      };
    if (!V) {
      var e;
      return {
        scrollHeight: ((e = O.current) === null || e === void 0 ? void 0 : e.offsetHeight) || 0,
        start: 0,
        end: n.length - 1,
        offset: void 0
      };
    }
    for (var r = 0, o, u, f, De = n.length, g = 0; g < De; g += 1) {
      var Ne = n[g], be = h(Ne), Q = j.get(be), D = r + (Q === void 0 ? m : Q);
      D >= c && o === void 0 && (o = g, u = r), D > c + i && f === void 0 && (f = g), r = D;
    }
    return o === void 0 && (o = 0, u = 0, f = Math.ceil(i / m)), f === void 0 && (f = n.length - 1), f = Math.min(f + 1, n.length), {
      scrollHeight: r,
      start: o,
      end: f,
      offset: u
    };
  }, [V, a, c, n, ye, i]), E = x.scrollHeight, y = x.start, _ = x.end, _e = x.offset;
  Y.current.start = y, Y.current.end = _;
  var L = E - i, P = v(L);
  P.current = L;
  function Te(e) {
    var r = e;
    return Number.isNaN(P.current) || (r = Math.min(r, P.current)), r = Math.max(r, 0), r;
  }
  var U = c <= 0, q = c >= L, Ce = $e(U, q);
  function Re(e) {
    var r = e;
    M(r);
  }
  function Ee(e) {
    var r = e.currentTarget.scrollTop;
    r !== c && M(r), R == null || R(e);
  }
  var Le = Be(a, U, q, function(e) {
    M(function(r) {
      var o = r + e;
      return o;
    });
  }), G = p(Le, 2), w = G[0], J = G[1];
  Ye(a, l, function(e, r) {
    return Ce(e, r) ? !1 : (w({
      preventDefault: function() {
      },
      deltaY: e
    }), !0);
  }), ee(function() {
    function e(r) {
      a && r.preventDefault();
    }
    return l.current.addEventListener("wheel", w), l.current.addEventListener("DOMMouseScroll", J), l.current.addEventListener("MozMousePixelScroll", e), function() {
      l.current && (l.current.removeEventListener("wheel", w), l.current.removeEventListener("DOMMouseScroll", J), l.current.removeEventListener("MozMousePixelScroll", e));
    };
  }, [a]);
  var Pe = ze(l, n, j, m, h, $, M, function() {
    var e;
    (e = B.current) === null || e === void 0 || e.delayHidden();
  });
  s.useImperativeHandle(re, function() {
    return {
      scrollTo: Pe
    };
  }), ee(function() {
    if (K) {
      var e = n.slice(y, _ + 1);
      K(e, n);
    }
  }, [y, _, n]);
  var we = We(n, y, _, xe, le, he), T = null;
  return i && (T = N(X({}, ne ? "height" : "maxHeight", i), qe), a && (T.overflowY = "hidden", de && (T.pointerEvents = "none"))), /* @__PURE__ */ s.createElement("div", Ie({
    style: N(N({}, oe), {}, {
      position: "relative"
    }),
    className: me
  }, se), /* @__PURE__ */ s.createElement(ae, {
    className: "".concat(d, "-holder"),
    style: T,
    ref: l,
    onScroll: Ee
  }, /* @__PURE__ */ s.createElement(Ke, {
    prefixCls: d,
    height: E,
    offset: _e,
    onInnerResize: $,
    ref: O,
    innerProps: fe
  }, we)), a && /* @__PURE__ */ s.createElement(Ve, {
    ref: B,
    prefixCls: d,
    scrollTop: c,
    height: i,
    scrollHeight: E,
    count: n.length,
    direction: F,
    onScroll: Re,
    onStartMove: function() {
      z(!0);
    },
    onStopMove: function() {
      z(!1);
    }
  }));
}
var Je = /* @__PURE__ */ s.forwardRef(Ge);
Je.displayName = "List";
export {
  Ge as RawList,
  Je as default
};
//# sourceMappingURL=List.mjs.map
